module.exports = __webpack_public_path__ + "static/media/version-1.c7fe20c7.jpg";